import { defineWave } from '../schema';

/** BLOC B — le PINCEMENT. Signature de mouvement : menace symétrique.
 *
 *  Deux Rôdeurs entrent par les extrémités et se croisent. Leurs éventails
 *  statiques ferment progressivement les côtés du terrain, ce qui pousse le
 *  joueur vers le centre — là où le popcorn arrive. La pression ne vient pas de
 *  la densité mais de la GÉOMÉTRIE.
 *
 *  C'est ce que le tir visé seul ne peut pas produire : une menace qui poursuit
 *  laisse toujours le terrain intact, une menace statique le sculpte. */
export default defineWave({
  id: 'b1-pincement',
  duration: 16,
  spawns: [
    { at: 0.0, enemy: 'rodeur', lane: 1, count: 1, spacing: 0 },
    { at: 0.3, enemy: 'rodeur', lane: 5, count: 1, spacing: 0 },
    { at: 2.5, enemy: 'mite', lane: 3, count: 6, spacing: 0.09 },
    { at: 5.0, enemy: 'eclat', lane: 2, count: 1, spacing: 0 },
    { at: 5.4, enemy: 'eclat', lane: 4, count: 1, spacing: 0 },
    { at: 8.0, enemy: 'rodeur', lane: 2, count: 1, spacing: 0 },
    { at: 8.4, enemy: 'rodeur', lane: 4, count: 1, spacing: 0 },
    { at: 11.0, enemy: 'mite', lane: 3, count: 8, spacing: 0.07 },
    { at: 13.5, enemy: 'eclat', lane: 3, count: 3, spacing: 0.7 },
  ],
});
